import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "item-dialog"
};
const _hoisted_2 = {
  class: "recommend-table"
};
const _hoisted_3 = {
  class: "search-form"
};
const _hoisted_4 = {
  class: "selected-count"
};
import { reactive, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import protoPagination from "@/components/proto-pagination.vue";
import { InfoFilled } from "@element-plus/icons-vue";
import { batchRemoveRecommendProductApi, bindRecommendProductApi, getProductCategoryListApi, getProductListByPageApi, getRecommendProductApi } from "@/service/modules/product";
import { getItemOrIngredApi, removeItemOrIngred, updateItemOrIngredApi } from "@/service/modules/scan";
const __default__ = {
  name: "RecommendDialog"
};
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    itemData: {
      type: Object,
      default: () => {}
    },
    type: {
      type: Number,
      default: 0
    },
    eatType: {
      type: Number,
      default: 1
    }
  },
  emits: ["closeDialog"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    onMounted(() => {
      getCategoryList();
      getList();
    });
    function handleRadioChange() {
      selectedIds.value = [];
      if (goodsTableRef.value) {
        goodsTableRef.value.clearSelection();
      }
      getList();
    }
    const page = reactive({
      current: 1,
      size: 10
    });
    const total = ref(0);
    const goodsList = ref([]);
    const isRecommend = ref(false);
    const categoryOptions = ref([]);
    const emit = __emit;
    const goodsTableRef = ref();
    let recommendType = ref(1);
    const handleOpen = function () {
      if (props.eatType == 4) {
        recommendType.value = 1;
      } else if (props.eatType == 5) {
        recommendType.value = 2;
      }
      isRecommend.value = false;
      getList();
    };
    function handleCurrentChange(currentPage) {
      page.current = currentPage;
      getList();
    }
    // 移除
    async function handleRemove(row) {
      console.log(123, row);
      try {
        let res = null;
        if (props.eatType <= 3) {
          res = await removeItemOrIngred({
            diseaseId: props.itemData.id,
            ids: [row.id],
            itemIds: [row.id],
            edible: props.eatType === 2 ? false : true,
            moderation: props.eatType === 3 ? true : false,
            updateType: 3,
            type: 3 // 商品类型
          });
        } else {
          res = await batchRemoveRecommendProductApi({
            productIds: [row.id],
            itemId: props.itemData.id,
            typeId: props.type,
            recommendType: recommendType.value
          });
        }
        ElMessage.success("移除成功");
        getList();
        selectedIds.value = [];
        if (goodsTableRef.value) {
          goodsTableRef.value.clearSelection();
        }
      } catch (error) {
        ElMessage.error("移除失败");
      }
    }
    // 批量移除
    async function handleBatchRemove() {
      console.log(123, selectedIds.value);
      try {
        let res = null;
        if (props.eatType <= 3) {
          res = await removeItemOrIngred({
            diseaseId: props.itemData.id,
            ids: [...selectedIds.value],
            itemIds: [...selectedIds.value],
            edible: props.eatType === 2 ? false : true,
            moderation: props.eatType === 3 ? true : false,
            updateType: 3,
            type: 3 // 商品类型
          });
        } else {
          res = await batchRemoveRecommendProductApi({
            productIds: [...selectedIds.value],
            itemId: props.itemData.id,
            typeId: props.type,
            recommendType: recommendType.value
          });
        }
        ElMessage.success("移除成功");
        getList();
        selectedIds.value = [];
        if (goodsTableRef.value) {
          goodsTableRef.value.clearSelection();
        }
      } catch (error) {
        ElMessage.error("移除失败");
      }
    }
    async function getCategoryList() {
      let res = await getProductCategoryListApi();
      categoryOptions.value = res.data;
    }
    // 获取商品列表数据
    async function getList() {
      // loading.value = true;
      if (isRecommend.value) {
        let data = {
          ...page,
          current: 1,
          itemId: props.itemData.id,
          typeId: props.type,
          all: true,
          eatType: props.eatType <= 3 ? props.eatType : undefined,
          recommendType: props.eatType <= 3 ? undefined : recommendType.value
        };
        let res = null;
        let list = [];
        if (props.eatType <= 3) {
          res = await getItemOrIngredApi({
            diseaseId: props.itemData.id,
            type: 3,
            // 成分类型
            name: searchForm.productName,
            edible: props.eatType === 2 ? false : true,
            moderation: props.eatType === 3 ? true : false,
            ...data,
            ...searchForm
          });
          list = res.data.records;
        } else {
          res = await getRecommendProductApi(data);
          list = res.data;
        }
        goodsList.value = list.map(item => ({
          ...item,
          id: item.productId || item.id
        }));
        total.value = 10;
      } else {
        let data = {
          ...page,
          ...searchForm,
          itemId: props.itemData.id,
          recommendType: props.eatType <= 3 ? undefined : recommendType.value,
          eatType: props.eatType <= 3 ? props.eatType : undefined
        };
        let res = await getProductListByPageApi(data);
        goodsList.value = res.data.records;
        total.value = Number(res.data.total);
      }
    }
    function closeDialog() {
      emit("closeDialog");
    }
    // 批量绑定
    async function handleBatchBind() {
      console.log(123, selectedIds.value);
      try {
        let res = null;
        if (props.eatType <= 3) {
          res = await updateItemOrIngredApi({
            diseaseId: props.itemData.id,
            ids: [...selectedIds.value],
            edible: props.eatType === 2 ? false : true,
            moderation: props.eatType === 3 ? true : false,
            updateType: 3
          });
        } else {
          res = await bindRecommendProductApi({
            productIds: [...selectedIds.value],
            itemId: props.itemData.id,
            typeId: props.type,
            recommendType: props.eatType <= 3 ? undefined : recommendType.value,
            eatType: props.eatType <= 3 ? props.eatType : undefined
          });
        }
        ElMessage.success("绑定成功");
        selectedIds.value = [];
        if (goodsTableRef.value) {
          goodsTableRef.value.clearSelection();
        }
        // closeDialog();
      } catch (error) {
        ElMessage.error("绑定失败");
      }
    }
    const searchForm = reactive({
      categoryId: "",
      isShelf: "",
      productName: ""
    });
    const selectedIds = ref([]);
    function handleSearch() {
      // 这里添加搜索逻辑
      console.log(123, "搜索条件：", searchForm);
      getList();
    }
    function handleReset() {
      searchForm.categoryId = "";
      searchForm.isShelf = "";
      searchForm.productName = "";
      selectedIds.value = [];
      getList();
    }
    function handleSelectionChange(selection) {
      console.log('handleSelectionChange', selection);
      selectedIds.value = selection.map(item => item.id);
    }
    return (_ctx, _cache) => {
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: isRecommend.value ? '已选择商品' : '选择商品',
        width: "1000px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog,
        onOpen: handleOpen
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_radio_group, {
          modelValue: isRecommend.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => isRecommend.value = $event),
          style: {
            "margin-bottom": "30px"
          },
          onChange: handleRadioChange,
          class: "recommend-radio-group"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_button, {
            value: false
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("选择商品")])),
            _: 1
          }), _createVNode(_component_el_radio_button, {
            value: true
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("已选择商品")])),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
          inline: true,
          model: searchForm
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "类目",
            prop: "categoryId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: searchForm.categoryId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchForm.categoryId = $event),
              placeholder: "请选择类目",
              clearable: "",
              style: {
                "width": "150px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryOptions.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.categoryName,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "状态",
            prop: "isShelf"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: searchForm.isShelf,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchForm.isShelf = $event),
              placeholder: "请选择状态",
              clearable: "",
              style: {
                "width": "150px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "已上架",
                value: true
              }), _createVNode(_component_el_option, {
                label: "未上架",
                value: false
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "",
            prop: "productName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: searchForm.productName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => searchForm.productName = $event),
              placeholder: "请输入搜索关键词",
              style: {
                "width": "200px"
              },
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: handleSearch
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("搜索")])),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: handleReset
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("重置")])),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_tag, {
          size: "small",
          type: "info",
          class: "selected-tag"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "info-icon"
          }, {
            default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
            _: 1
          }), _createTextVNode(" 已选择 " + _toDisplayString(selectedIds.value.length) + " 项 ", 1)]),
          _: 1
        })]), _createVNode(_component_el_table, {
          ref_key: "goodsTableRef",
          ref: goodsTableRef,
          data: goodsList.value,
          onSelectionChange: handleSelectionChange,
          style: {
            "max-height": "450px",
            "overflow-y": "auto"
          },
          "header-cell-style": {
            background: '#F7F9FB !important',
            color: '#111111',
            height: '42px',
            fontSize: '14px'
          }
        }, {
          empty: _withCtx(() => _cache[9] || (_cache[9] = [_createElementVNode("div", {
            class: "table-empty"
          }, [_createElementVNode("img", {
            class: "no-data",
            src: _imports_0,
            alt: ""
          }), _createElementVNode("div", {
            class: "empty-text"
          }, "暂无数据")], -1)])),
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }), _createVNode(_component_el_table_column, {
            prop: "id",
            label: "ID",
            width: "180"
          }), _createVNode(_component_el_table_column, {
            prop: "productName",
            label: "商品信息",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "price",
            label: "最低价",
            width: "120"
          }), _createVNode(_component_el_table_column, {
            prop: "maxPrice",
            label: "最高价",
            width: "120"
          }), isRecommend.value ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            label: "操作",
            width: "120"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_link, {
              type: "danger",
              onClick: $event => handleRemove(scope.row)
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("移除")])),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["data"]), _createVNode(protoPagination, {
          page: page,
          total: total.value,
          layout: "prev, pager, next",
          onCurrentChange: handleCurrentChange
        }, null, 8, ["page", "total"]), !isRecommend.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: handleBatchBind
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("批量绑定")])),
          _: 1
        })) : _createCommentVNode("", true), isRecommend.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "danger",
          onClick: handleBatchRemove
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("批量移除")])),
          _: 1
        })) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});